import { useState, useContext, ChangeEvent } from "react"
import { useHttp } from "../hooks/http.hook"
import { AuthContext } from "../context/authContext"
import { LoadingBar } from "./loadingBar"
import { readFile, utils } from 'xlsx'

export const CoaComponent = (props: {page :string}) => {
    const auth = useContext(AuthContext)
    const { loading, request, error, clearError } = useHttp()
    const [link, setLink] = useState('')
    const [empty, setEmpty] = useState([])

    const changeHandler = async (e: ChangeEvent) => {
      setLink('')
      setEmpty([])
      clearError()
      const inputElement = e.target as HTMLInputElement;
      if (!inputElement.files?.length) return

      let data:[] = []
      // @ts-ignore
      const workbook = readFile(await inputElement.files[0].arrayBuffer(), { type: 'binary' })
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      utils.sheet_to_json(worksheet).forEach((item: any)=>{
        // @ts-ignore
        data.push({cas: Object.values(item)[0], lot: Object.values(item)[1], company: Object.values(item)[2]})
      })
      const { empty_files, link } = await request('/products/coa', "POST", data, {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.token}`
      })
      setLink(link)
      setEmpty(empty_files)
    }

    return(
      <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
        <h4>{props.page.toLocaleUpperCase()}</h4>
        <span style={{color: "sienna", opacity: 0.7 }}>Работаем с Macklin</span>
        <div className="input-field" style={{width: '40%', marginTop: '0', display: 'flex', flexDirection: 'column'}}>
          <form action="#">
            <div className="file-field input-field">
              <div className="btn">
                <span>File</span>
                <input type="file" onChange={changeHandler} disabled={loading}/>
              </div>
              <div className="file-path-wrapper">
                <input className="file-path validate" type="text" placeholder="Вставьте файл xlsx с таблицей лотов"/>
              </div>
            </div>
          </form>
          <div style={{width: "95%", marginTop: "4em"}}>
            {
              error && <div className="red-text center-align">{error}</div>
            }
            {
              loading && <LoadingBar text="Идет формирование файла" />
            }
          </div>
          <div style={{width: "95%"}}>
            {
              link && <div className="red-green center-align" style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                {
                  empty.length > 0 && <span style={{marginBottom: '1em', fontWeight: 'bold'}}>Не удалось скачать coa для артикулов: {empty.join(',')}</span>
                }
                <span style={{marginBottom: '1em'}}>Файл успешно сформирован. Нажмите на ссылку для скачивания.</span>
                <a href={"/uploads/" + link} target="blank" download={link}>Скачать файл</a>
              </div>
            }
          </div>
        </div>
      </div>
    )
}